import ViewTherapist from './ViewTherapist'
export default ViewTherapist
